import React from 'react'
import HeightMatchingGroup from '../components/height-matching-group'
import { useMutation } from '@apollo/client'
import fetchProjects from '../queries/project-list'
import renameProject from '../mutations/rename-project'
import ProjectActions from '../components/project-actions'
import debounce from 'debounce'
import format from 'date-fns/format'

const countStudents = (sections) => {
  return (
    sections &&
    sections.map((s) => s.students.length).reduce((i, acc) => i + acc, 0)
  )
}

const goToProjectEdit = (projectId) => {
  window.location.href = `/projects/${projectId}/edit`
}

function ProjectRow(props) {
  const [name, setName] = React.useState(props.data.name)
  const [showActions, setShowActions] = React.useState(false)
  const [showRename, setShowRename] = React.useState(false)
  const [renameProjectMutation] = useMutation(renameProject)
  const nameInput = React.useRef(null)

  React.useEffect(() => {
    if (!showRename) {
      nameInput.current.focus()
      nameInput.current.select()
    }
  }, [showRename])

  const stopPropagation = (e) => {
    e.stopPropagation()
  }

  const renameThisProject = debounce((name) => {
    const { id } = props.data

    if (name.length > 0) {
      renameProjectMutation({
        variables: { id, name },
        refetchQueries: [{ query: fetchProjects }],
      })
    }
  }, 500)

  const toggleActions = (e) => {
    e.stopPropagation()
    setShowActions(!showActions)
  }

  const handleNameChange = (e) => {
    const name = e.target.value
    setName(name)
    renameThisProject(name)
  }

  const handleKeyUp = (e) => {
    const keyCode = e.keyCode
    if (keyCode === 13) {
      toggleRename(e)
    }
  }

  const toggleRename = (e) => {
    e.stopPropagation()
    setShowRename(!showRename)
  }
  const handleClickShare = (e) => {
    e.stopPropagation()
    props.toggleShareProject(props.data)
  }

  const { id, collaborator, liveQuestions, owner, sections, inserted_at } =
    props.data
  const group =
    props.data &&
    props.data.sections &&
    props.data.sections[0] &&
    props.data.sections[0].group
  const sectionNames =
    sections && sections.map((s) => s.name.replace(/\s/g, '\u00A0')).join(', ')
  const numStudents = countStudents(sections)
  const numQuestions = (liveQuestions && liveQuestions.length) || 0
  const colleague = props.isShared
    ? owner.name
    : (collaborator && collaborator.name) || ''
  const nameClasses = showRename ? 'project-name renaming' : 'project-name'

  return (
    <HeightMatchingGroup
      tagName="tr"
      selector=".match-height"
      onClick={() => goToProjectEdit(id)}
    >
      <td className={nameClasses}>
        <div className="match-height">
          <strong>{name}</strong>
          <div className="field floating" onClick={stopPropagation}>
            <input
              type="text"
              value={name}
              onBlur={toggleRename}
              onChange={handleNameChange}
              onKeyUp={handleKeyUp}
              ref={(input) => {
                nameInput.current = input
              }}
              required
            />
            <div className="highlight" />
          </div>
        </div>
      </td>
      <td>
        <div className="match-height">
          {format(inserted_at, 'MMM, dd, yyyy')}
        </div>
      </td>
      <td className="section-names">
        {group ? (
          <div className="match-height">
            <p>
              <strong style={{ color: `#${group.color}` }}>{group.name}</strong>
              {'\u00a0'}({sectionNames})
            </p>
          </div>
        ) : (
          <div className="match-height" />
        )}
      </td>
      <td>
        <div className="match-height">{numStudents}</div>
      </td>
      <td>
        <div className="match-height">{numQuestions}</div>
      </td>
      <td>
        <div className="match-height">{colleague}</div>
      </td>
      <td className="share">
        {props.isShared ? (
          <div className="match-height" />
        ) : (
          <div className="match-height" onClick={handleClickShare}>
            <i className="material-icons">person_add</i>
          </div>
        )}
      </td>
      <td className="actions">
        {props.isShared ? (
          <div className="match-height" />
        ) : (
          <div className="match-height">
            <ProjectActions
              id={id}
              toggleOpen={toggleActions}
              toggleRename={toggleRename}
              isOpen={showActions}
              canDelete={props.data?.liveQuestions?.length === 0}
            />
          </div>
        )}
      </td>
    </HeightMatchingGroup>
  )
}

export default ProjectRow
